var map = {
	"./earlyMorningShift.svg": "0540",
	"./en-US.svg": "4ad7",
	"./exit.svg": "54f9",
	"./exit1.svg": "19fc",
	"./help.svg": "e336",
	"./help1.svg": "55de",
	"./home-page-add.svg": "90f8",
	"./home-page-added.svg": "2d05",
	"./home-page-delete.svg": "b12e",
	"./horn.svg": "a85d",
	"./huanbanguanli.svg": "c5c6",
	"./huanbanguanli1.svg": "9c69",
	"./language.svg": "c7a8",
	"./morningShift.svg": "21c2",
	"./nightShift.svg": "e137",
	"./noonShift.svg": "7b66",
	"./shiftHandover.svg": "3dcb",
	"./shiftHandover1.svg": "20bf",
	"./zh-CN.svg": "539c",
	"./zh-HK.svg": "d9bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";